import { render, staticRenderFns } from "./ReadOnlyCartItem.vue?vue&type=template&id=5cf4abca&"
import script from "./ReadOnlyCartItem.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyCartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports